import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { MeTeam } from '@scio3/shared-types';

interface TeamState {
  teams: MeTeam[];
  activeTeamId: string;

  setTeams: (teams: MeTeam[]) => void;
  setActiveTeam: (teamId: string) => void;
  getActiveTeam: () => MeTeam | undefined;
  clearTeams: () => void;
}

export const useTeamStore = create<TeamState>()(
  persist(
    (set, get) => ({
      teams: [],
      activeTeamId: '',

      setTeams: (teams) => {
        const current = get().activeTeamId;
        const isValid = current && teams.some((t) => t._id === current);
        set({
          teams,
          ...(isValid ? {} : { activeTeamId: teams[0]?._id ?? '' }),
        });
      },
      setActiveTeam: (teamId) => set({ activeTeamId: teamId }),
      getActiveTeam: () => get().teams.find((t) => t._id === get().activeTeamId),
      clearTeams: () => set({ teams: [], activeTeamId: '' }),
    }),
    { name: 'scio3-team' },
  ),
);
